import { render, staticRenderFns } from "./buy-books.vue?vue&type=template&id=3f43dfb6&scoped=true"
import script from "./buy-books.vue?vue&type=script&lang=js"
export * from "./buy-books.vue?vue&type=script&lang=js"
import style0 from "./buy-books.vue?vue&type=style&index=0&id=3f43dfb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f43dfb6",
  null
  
)

export default component.exports